import api from 'utils/api';

export const fetchConceptsListRequest = (page, params) =>
  api.callPost(`admin/concepts?page=${page}&limit=30`, params);

export const fetchOverviewRequest = ({ conceptId, partnerId }, pagination) =>
  api.callGet(
    `admin/concepts/overview?concept_id=${conceptId}&partner_id=${partnerId}&page=${
      pagination?.page ?? 1
    }`
  );

export const fetchSubscribersRequest = ({ partnerId }) =>
  api.callGet(`admin/concepts/subscriber?partner_id=${partnerId}`);

export const fetchAssigneesRequest = ({ type, relId }) =>
  api.callGet(`admin/assignees?type=${type}&rel_id=${relId}`);

export const fetchAllTags = () => api.callGet(`admin/tags`);

export const fetchTagsRequest = ({ relId }) =>
  api.callGet(`admin/tags?rel_id=${relId}`);

export const fetchConceptByPartner = (id, page) =>
  api.callGet(`admin/concepts/list?partner_id=${id}&page=${page}&limit=1000`);

// Accepts a comma-separated list of partner ids.
// list-v3 answers with a flat array and no pagination metadata, so the result is
// reshaped into the paginated envelope the concept dropdown expects.
export const fetchConceptByPartnerV3 = async (id, page) => {
  const response = await api.callGet(
    `admin/concepts/list-v3?partner_id=${id}&page=${page}&limit=1000`
  );

  if (response?.success === false) return response;

  const currentPage = Number(page) || 1;
  const list = Array.isArray(response)
    ? response
    : Array.isArray(response?.data)
    ? response.data
    : response?.data?.data ?? [];

  return {
    success: true,
    data: {
      data: list,
      current_page: currentPage,
      last_page: currentPage,
      total: list.length,
    },
  };
};

export const fetchLinkList = (rel_id) =>
  api.callGet(`admin/link?rel_id=${rel_id}&rel_type=1`);

export const updateStatusRequest = (params) =>
  api.callPost('admin/task/update-status', params);

export const updateConceptStatusRequest = (params) =>
  api.callPost('admin/concepts/update-status', params);

export const updateDealIdRequest = (params) =>
  api.callPost('admin/concepts/update-deal-id', params);

export const updateMembersRequest = (params) =>
  api.callPost('admin/member/update', params);

export const updateAssigneesRequest = (params) =>
  api.callPost('admin/assignees/add-remove', params);

export const updateTagsRequest = (params) =>
  api.callPost('admin/tags/add', params);

export const updateAssetDownloadRequest = (params) =>
  api.callPost('admin/concepts/downloading-assets', params);

export const requestDestroyLinkList = (params) =>
  api.callPost(`admin/link/delete`, params);

export const createLinkList = (params) =>
  api.callPost(`admin/link/create`, params);

export const updateLinkList = (params) =>
  api.callPost(`admin/link/update`, params);

export const filterLinkList = (id, params) =>
  api.callPost(`admin/link/filter?rel_id=${id}&rel_type=1`, params);
